// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popertyDetails .cell {\n  text-align: center;\n}\n.popertyDetails .popertyDetails-table {\n  margin-top: 30px;\n}\n.popertyDetails .el-table__footer-wrapper tbody td {\n  color: red;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
